// src/pages/Login.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/LoginRegister.css';
import EMAIL from '../assets/imagens/EMAIL.png';
import SENHA from '../assets/imagens/SENHA.png';
const apiUrl = process.env.REACT_APP_API_URL;

function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { saveToken } = useAuth();

  useEffect(() => {
    document.body.classList.add('login-register-body');
    return () => {
      document.body.classList.remove('login-register-body');
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch(`${apiUrl}admins/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ email, senha })
      });

      if (!response.ok) {
        throw new Error('Login failed');
      }

      const data = await response.json();

      if (data.token) {
        saveToken(data.token);
        navigate('/hall', { state: { user: email } });
      } else {
        setError('Invalid email or password');
      }
    } catch (error) {
      setError('Um erro ocorreu. Tente Novamente!');
    }
  };

  return (
    <div className="login-container">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <div className="input-container">
          <img src={EMAIL} alt="email" className="input-icon" />
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
        </div>
        <div className="input-container">
          <img src={SENHA} alt="senha" className="input-icon" />
          <input type="password" value={senha} onChange={(e) => setSenha(e.target.value)} placeholder="Senha"/>
        </div>
        {error && <p>{error}</p>}
        <button type="submit">Login</button>
      </form>
      <button onClick={() => navigate('/register')}>Cadastrar</button>
    </div>
  );
}

export default Login;